<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row style="height:15px;"></Row>
    <Row>
      <Table
        size="small"
        :stripe="true"
        :border="true"
        :columns="huobi_otc_table_columns"
        :data="huobi_otc_table_data"
        ref="huobi_otc_table_ref"
        :max-height="600"
      ></Table>
    </Row>
  </div>
</template>


<script>
export default {
  name: "tools_otc_supervisor",
  data() {
    return {
      table_title: "火币OTC监控",
      huobi_otc_table_columns: [
        { title: "币种", key: "currency_name", align: "center" },
        {
          title: "普通交易",
          align: "center",
          children: [
            {
              title: "商家买入",
              align: "center",
              children: [
                { title: "价格", align: "center", key: "general_price_buy" },
                { title: "数量", align: "center", key: "general_amount_buy" }
              ]
            },
            {
              title: "商家卖出",
              align: "center",
              children: [
                { title: "价格", align: "center", key: "general_price_sell" },
                { title: "数量", align: "center", key: "general_amount_sell" }
              ]
            }
          ]
        },
        {
          title: "大宗交易",
          align: "center",
          children: [
            {
              title: "商家买入",
              align: "center",
              children: [
                { title: "价格", align: "center", key: "block_price_buy" },
                { title: "数量", align: "center", key: "block_amount_buy" }
              ]
            },
            {
              title: "商家卖出",
              align: "center",
              children: [
                { title: "价格", align: "center", key: "block_price_sell" },
                { title: "数量", align: "center", key: "block_amount_sell" }
              ]
            }
          ]
        }
      ],
      huobi_otc_table_data: [
        {
          currency_name: "BTC",
          general_price_buy: 60350.0,
          general_amount_buy: 3.0,
          block_price_buy: 60245.5,
          block_amount_buy: 997.0,
          general_price_sell: 60489.0,
          general_amount_sell: 0.009127,
          block_price_sell: 60688.0,
          block_amount_sell: 2.207418
        }
      ],
      timer: null,
    };
  },
  methods: {
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.draw_table_huobi_otc()
        }, interval);
      }
    },
    draw_table_huobi_otc: async function() {
      let data = await this.$axios.get(
          this.$store.state.urlPort + "/load_tools_data",
          {
            params: {
              mode: "otc_supervisor",
              which_web_need: this.strategy_id,
            }
          }
        )
      this.huobi_otc_table_data = data
    },
  },
  mounted() {
    this.strategy_id = this.$route.path.split("=")[1];
    this.draw_table_huobi_otc()
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer(30000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>